import { useQueryClient, type UseQueryOptions } from "@tanstack/react-query"

/**
 * Хук, который возвращает функцию для инвалидации запросов, созданных с помощью семейства хуков `use*Query`
 * @param query
 */
export function useQueryRefresher(query: UseQueryOptions) {
	const queryClient = useQueryClient()
	return () => queryClient.invalidateQueries({
		...query,
		exact: true
	})
}